import axios from "axios";

export function authorizationHeader() {
  return {
    headers: {
      "Authorization": 'Bearer ' + sessionStorage.getItem('access_token')
    }
  };
}



// axios request custom function
export async function getAxios(apiBaseUrl) {
  try {
    var req = await axios.get(apiBaseUrl, { ...authorizationHeader() })
  } catch (e) {
    throw e;
  } finally {
  }
  return req;
}


// axios request custom function
export async function postAxios(apiBaseUrl, data) {
  try {
    var req = await axios.post(apiBaseUrl, data, { ...authorizationHeader() })
  } catch (e) {
    throw e;
  } finally {
  }
  return req;
}

// axios request custom function
export async function putAxios(apiBaseUrl, data) {
  try {
    var req = await axios.put(apiBaseUrl, data, { ...authorizationHeader() })
  } catch (e) {
    throw e;
  } finally {
  }
  return req;
} 